<p class="history-head">Upload History</p>
@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-table
  #dt
  class="table"
  dataKey="m365eventId"
  selectionMode="single"
  [paginator]="true"
  [columns]="scrollableCols"
  [rows]="dataViewRecsPerPage"
  [value]="partnerWorkshopUploadHistory"
  [totalRecords]="totalRecords"
  [loadingIcon]="loadingIcon"
  [showLoader]="true"
  [scrollable]="true"
  [lazy]="true"
  (onPage)="pageChange($event)"
  paginatorPosition="top"
  scrollHeight="550px"
  exportFilename="M365EventRecords"
  [style]="{ width: '100%' }">
  <ng-template pTemplate="caption">
    <div class="ui-g-4 filter">
      <span class="filter-by">Filter by: </span>
      <p-select
        [showClear]="true"
        #dropdown
        class="type-dropdown"
        [options]="fileTypes"
        optionLabel="type"
        placeholder="Select Customer or Partner"
        (onChange)="filterTable($event)"></p-select>
    </div>
    <div class="align-table-head">
      <div>
        <button
          class="ui-button btn-upload ui-state-default ui-button-info"
          (click)="showUploadDialog()"
          [disabled]="!isWorkshopTypeSelected">
          Upload Documents
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #header let-columns>
    <tr class="row">
      <th class="colsmall">Active</th>
      <th class="collarge">File Name</th>
      <th class="colsmall">File Type</th>
      <th [pSortableColumn]="'createdOn'" class="colsmall">
        Upload Date<p-sortIcon [field]="'createdOn'"> </p-sortIcon>
      </th>
      <th class="colmedium">Uploaded by</th>
      <th class="colmedium">Errors</th>
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns">
    <tr class="row">
      <td class="colsmall">
        @if (rowData.active) {
          <div class="active-box active-box-green">Yes</div>
        }
        @if (!rowData.active) {
          <div class="active-box active-box-red">No</div>
        }
      </td>
      <td
        class="collarge"
        tooltipPosition="top"
        pTooltip="{{ rowData.documentDisplayName }}">
        <a
          (click)="downloadFile(rowData)"
          (keydown.enter)="downloadFile(rowData)"
          tabindex="0"
          >{{ rowData.documentDisplayName }}</a
        >
      </td>
      <td class="colsmall">
        <span>{{ rowData.fileType }}</span>
      </td>
      <td class="colsmall">
        <span>{{ rowData.createdDate | date: 'MM/dd/yyyy' }}</span>
      </td>
      <td
        class="colmedium"
        tooltipPosition="top"
        pTooltip="{{ rowData.createdByUser?.firstName }}">
        <span>{{ rowData.createdByUser?.firstName }}</span>
      </td>
      <td class="colmedium">
        <a
          (click)="viewLog(rowData.uploadResult, rowData.fileType)"
          (keydown.enter)="viewLog(rowData.uploadResult, rowData.fileType)"
          tabindex="0"
          >View Log</a
        >
      </td>
    </tr>
  </ng-template>
</p-table>
<app-partner-document-upload
  #uploadDocumentDialogue
  (uploadCompletedEvent)="loadWorkshopUploadHistory(-1)"
  [isHybridWithCustomerList]="
    isHybridWithCustomerList
  "></app-partner-document-upload>
<app-access-list-error-log
  #viewLogModal
  [showLogs]="showLogs"></app-access-list-error-log>
